import * as React from "react"

/**
 * A coloured, softly shaded bell (warm gold with a highlight) for the phone header, drawn as SVG so it looks
 * the same on every device, unlike the emoji bell, which each platform draws its own way.
 */
export function Bell3DIcon({ className }: { className?: string }) {
  const id = React.useId().replace(/:/g, "")
  return (
    <svg viewBox='0 0 24 24' className={className} aria-hidden fill='none'>
      <defs>
        <linearGradient id={`${id}-body`} x1='6' y1='3' x2='18' y2='19' gradientUnits='userSpaceOnUse'>
          <stop offset='0' stopColor='#FDE68A' />
          <stop offset='0.45' stopColor='#FBBF24' />
          <stop offset='1' stopColor='#D97706' />
        </linearGradient>
        <linearGradient id={`${id}-rim`} x1='4' y1='16' x2='20' y2='19' gradientUnits='userSpaceOnUse'>
          <stop offset='0' stopColor='#F59E0B' />
          <stop offset='1' stopColor='#B45309' />
        </linearGradient>
        <radialGradient id={`${id}-clapper`} cx='12' cy='20.2' r='2.4' gradientUnits='userSpaceOnUse'>
          <stop offset='0' stopColor='#FCD34D' />
          <stop offset='1' stopColor='#B45309' />
        </radialGradient>
      </defs>
      {/* top loop */}
      <circle cx='12' cy='3.4' r='1.35' fill='#D97706' />
      {/* clapper */}
      <circle cx='12' cy='20.2' r='2.1' fill={`url(#${id}-clapper)`} />
      {/* body */}
      <path
        d='M12 4.4c-3.4 0-5.7 2.6-5.7 6v3.1c0 .9-.5 1.8-1.2 2.4l-.6.5c-.5.4-.2 1.2.4 1.2h14.2c.6 0 .9-.8.4-1.2l-.6-.5c-.7-.6-1.2-1.5-1.2-2.4v-3.1c0-3.4-2.3-6-5.7-6Z'
        fill={`url(#${id}-body)`}
      />
      {/* rim */}
      <rect x='4.3' y='16.4' width='15.4' height='1.9' rx='0.95' fill={`url(#${id}-rim)`} />
      {/* highlight */}
      <path d='M8.4 7.6c.7-1.3 1.9-2.1 3.1-2.3' stroke='#FFFBEB' strokeOpacity='0.85' strokeWidth='1.3' strokeLinecap='round' />
      <ellipse cx='9.2' cy='11.2' rx='0.9' ry='2.2' fill='#FFFBEB' fillOpacity='0.45' />
    </svg>
  )
}
